<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="container px-5">
      <router-link v-if="!isAuth" class="navbar-brand" to="/" >JIR</router-link>
      <router-link v-else class="navbar-brand" to="/dashboard" >JIR</router-link>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">

        </ul>
      </div>
    </div>
  </nav>
</template>

<script>

export default {
  inject: ['$localStorageService'],
  name: 'Header-Component',
  components: {

  },
  data() {
    return {

    }
  },
  computed: {
    isAuth() {
      return this.$localStorageService.isAuth();
    },
    nombreUsuario() {
      return this.$localStorageService.getNombreCompleto();
    }
  },
  created() {
  },
  async mounted() {
  },
  methods: {
    cerrarSesion() {
      this.$localStorageService.destroy();
      this.$router.push({ name: 'login' }).then(() => {
        this.$router.go(0);
      });

    }
  },
  filters: {

  }
};
</script>

<style scoped>

</style>
